// extracted by mini-css-extract-plugin
export default {"ciabatta":"CiabattaBody_ciabatta__YPGmP","ciabattaBody":"CiabattaBody_ciabattaBody__d5H1E"};